<template>
  <div class="container">
    <el-button type="primary" size="medium" icon="el-icon-plus" @click="adds">新增</el-button>
    <el-table v-loading="loading" border :data="tableData" >
      <el-table-column type="index" align="center" />
      <el-table-column label="代理商名称" prop="companyName" align="center" min-width="160" :show-overflow-tooltip="true" />
      <el-table-column label="代理商层级" prop="companyPath" min-width="160" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="支付账号" prop="dictValue" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="{row}">
          <p>{{row.extra && row.extra.mchId ? row.extra.mchId : '-'}}</p>
          <p style="font-size: 12px;">{{row.extra && row.extra.mchName ? row.extra.mchName : '-'}}</p>
        </template>
      </el-table-column>
      <el-table-column label="公众号支付" prop="dictValue" min-width="80" align="center" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <el-tag type="success" v-if="row.extra && row.extra.wechatPublic =='1'">已开通</el-tag>
          <el-tag v-else type="danger">未开通</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="H5支付" prop="dictValue" min-width="80" align="center" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <el-tag type="success" v-if="row.extra && row.extra.wechatH5 =='1'">已开通</el-tag>
          <el-tag v-else type="danger">未开通</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="小程序支付" prop="dictValue" min-width="80" align="center" :show-overflow-tooltip="true">
        <template slot-scope="{row}">
          <el-tag type="success" v-if="row.extra && row.extra.wechatProgram =='1'">已开通</el-tag>
          <el-tag v-else type="danger">未开通</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="作用范围" prop="level" min-width="160" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="{row}">
          <span v-if="row.level =='1'">当前账号</span>
          <span v-if="row.level =='2'">当前账号及下级</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="level" min-width="60" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="{row}">
          <span v-if="row.status =='1'">有效</span>
          <span v-else>无效</span>
        </template>
      </el-table-column>
      <el-table-column label="创建人" prop="createUser" min-width="100" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="创建时间" prop="createTime" min-width="120" align="center" :show-overflow-tooltip="true" />
      <el-table-column label="操作" align="center" min-width="70" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button size="mini" type="text" v-hasPermi="['agent:dict:edit']" @click="edit(scope.row)">编辑</el-button>
          <el-button size="mini" type="text" v-hasPermi="['agent:dict:del']" @click="del(scope.row)">移除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" :visible.sync="dialog" :lock-scroll="false" width="700px" append-to-body v-dialogDrag :close-on-click-modal="false">
      <el-form :model="form" label-width="80px" ref="form" :rules="rules">
        <el-form-item label="代理商名称:" prop="userId" label-width="100px">
          <el-select :disabled="!!form.id" v-model="form.userId" filterable placeholder="请选择代理商" clearable style="width:90%">
            <el-option v-for="(item,index) in agentData" :key="index" :label="'['+item.username+']-' + item.company" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付商号:" prop="mchId" label-width="100px">
          <el-select v-model="form.mchId" filterable placeholder="请选择支付商号" clearable style="width:90%">
            <el-option v-for="(item,index) in mchSources" :key="index" :label="'['+item.mchId+']-' + item.name" :value="item.mchId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公众号支付:" prop="wechatPublic" label-width="100px">
          <el-radio-group v-model="form.wechatPublic">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="H5支付:" prop="wechatH5" label-width="100px">
          <el-radio-group v-model="form.wechatH5">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="小程序支付:" prop="wechatProgram" label-width="100px">
          <el-radio-group v-model="form.wechatProgram">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="作用范围:" prop="level" label-width="100px">
          <el-radio-group v-model="form.level">
            <el-radio label="1">当前账号</el-radio>
            <el-radio label="2">当前账号及下级</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="状态:" prop="status" label-width="100px">
          <el-radio-group v-model="form.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { agentDictList , agentList , agentDictSave , agentDictUpdate , agentDictDel ,payConfigSource} from "@/api/api";
export default {
  name: "AgentPay",
  data() {
    return {
      loading:false,
      tableData:[],
      title:'',
      dialog:false,
      mchSources:[],
      form:{
        id:undefined,
        userId:undefined,
        mchId:undefined,
        dictValue:undefined,
        status:"1",
        wechatPublic:"1",
        wechatH5:"0",
        wechatProgram:"1",
        level:"1"
      },
      rules:{
        userId:[
          { required: true, message: "请选择代理商", trigger: "blur" }
        ],
        level:[
          { required: true, message: "请选择作用范围", trigger: "blur" }
        ]

      },
      agentData:[]
    };
  },
  methods:{
    initData(){
      let key = "AgentPayConfig";
      agentDictList({key}).then(res=>{
        this.tableData = res.data.data
      })
    },
    //获取所有支付商号
    mchSource(){
      let type = '1';
      let status = '1';
      payConfigSource({type,status}).then(res=>{
        this.mchSources = res.data.data;
      })
    },
    submitForm(){
      this.$refs.form.validate(valid => {
        if (valid) {
          if (!!this.form.id) {
            this.form.dictKey = 'AgentPayConfig'
            this.form.dictValue = null
            this.form.dictValue = JSON.stringify(this.form)
            agentDictUpdate(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }else{
            this.form.dictKey = 'AgentPayConfig'
            this.form.dictValue = JSON.stringify(this.form)
            agentDictSave(this.form).then(res=>{
              this.initData()
              this.dialog = false
            })
          }
        }
      })
    },
    selectAgentList() {
      agentList().then(res => {
        this.agentData = res.data.data;
      });
    },
    adds(){
      this.dialog = true
      this.title = "新增代理商支付"
      this.form={level:'1',wechatPublic:"1",wechatH5:"0",wechatProgram:"1",status:"1"}
    },
    edit(row){
      this.dialog = true
      this.title = "修改代理商支付"
      const extra = row.extra || '{}';
      let form = {
        id:row.id,
        userId : row.userId,
        dictValue : row.dictValue,
        level : row.level,
        status: row.status,
        mchId: extra.mchId,
        wechatPublic: extra.wechatPublic || "1",
        wechatH5: extra.wechatH5 || "0",
        wechatProgram: extra.wechatProgram || "1"
      }
      this.form = form
    },
    //删除免显
    del(row){
      let id = row.id
      this.$confirm("此操作将删除此代理商支付，恢复系统支付, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
			}).then(() => {
        agentDictDel({id}).then(res=>{
          this.$notify({
            title: '成功',
            message: '代理商支付配置删除成功',
            type: 'success'
          });
          this.initData();
        })
      })
    }
  },
  created() {
    this.initData()
    this.mchSource()
    this.selectAgentList()
  },
};
</script>